import { render, staticRenderFns } from "./IdleModal.vue?vue&type=template&id=1f4b11c6"
import script from "./IdleModal.vue?vue&type=script&lang=js"
export * from "./IdleModal.vue?vue&type=script&lang=js"
import style0 from "./IdleModal.vue?vue&type=style&index=0&id=1f4b11c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports